import { AutogenLayoutOnHoldInvoiceReasonCodeQuickInfo } from "./autogen/AutogenLayoutOnHoldInvoiceReasonCodeQuickInfo";

export class OnHoldInvoiceReasonCodeQuickInfo extends AutogenLayoutOnHoldInvoiceReasonCodeQuickInfo {
    private _reasonText;

    afterExecution() {
        if (this.reasonText) {
            this.textboxReasonText.text = this.reasonText;
        }
    }
    
    
    public get reasonText() : string {
        return this._reasonText;
    }
    
    
    public set reasonText(value: string) {
        this._reasonText = value;
    }
    
}